// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Fpyi","title":"Info_title__XoXll","selects":"Info_selects__S_Xjp","requiredAsterisk":"Info_requiredAsterisk__3rTKF"};